/**
 * Host → viewer messages for «Koble tegning».
 * Camera + section + overlay plane only. Never rematch / set-storey / transforms.
 */

export function linkDrawingEnterMessages({ elevationM } = {}) {
  const messages = [
    { type: "drawing:overlay", enabled: true },
    { type: "ifc:set-view", preset: "top" },
  ];
  if (Number.isFinite(elevationM)) {
    messages.push({
      type: "ifc:set-section",
      enabled: true,
      axis: "z",
      elevation: elevationM,
    });
  }
  return messages;
}

export function linkDrawingLeaveMessages({ restoreView = true } = {}) {
  const messages = [{ type: "drawing:overlay", enabled: false, restoreView }];
  if (restoreView) messages.push({ type: "ifc:set-tool", tool: "select" });
  return messages;
}

/** True if a host message would move models or hide unmapped RIV. */
export function linkDrawingMessageMutatesPlacement(message) {
  const type = message?.type;
  return (
    type === "ifc:auto-align" ||
    type === "ifc:remerge" ||
    type === "ifc:set-transform" ||
    type === "ifc:set-storey-map" ||
    type === "ifc:set-storey" ||
    type === "ifc:nudge"
  );
}
